/* 🤖 this file was generated by script */
export const wiconXCircle = {
  name: 'x_circle',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 9l-6 6m0-6l6 6m7-3a10 10 0 11-20 0 10 10 0 0120 0z"/></svg>`,
};
